const gaugeInsightPalettes = {
  morning: {
    primary: '#E7A90B',
    soft: '#F5E7BF',
    accent: '#B27600',
    badgeBg: '#F8EDCC',
    badgeText: '#9C6700',
  },

evening: {
  primary: '#FF8A34',
  soft: '#FFF1E7',
  accent: '#D65A00',
  badgeBg: '#FFE4CF',
  badgeText: '#B84A00',
},

night: {
  primary: '#3B82F6',
  soft: '#E8F1FF',
  accent: '#1D4ED8',
  badgeBg: '#DBEAFE',
  badgeText: '#1E40AF',
},
}

export const widgetsGauge: CommonWidget = {

  gaugeGeneric: {
    title: 'FALTA',

    position: [0, 0],

    size: [0, 0],

    config: {
      id: 'gauge-generic',
      type: 'gauge',
      fillMode: '',
      color: '#33b9ce',
      showValues: true,
      showHistoric: false,
      maxValue: 10,
      decimals: 1,
      center: ['50%', '50%'],
      radius: '90%',

      indicators: [
        {
          indicator: 'FALTA',
          keyExtract: ['group', 'count', 'value'],
          value: 'value',
          extras: {},
        },
      ],
    },
  },

  gaugeGenericByStatus: {
    title: 'FALTA',

    position: [0, 0],

    size: [0, 0],

    config: {
      id: 'gauge-generic-by-status',
      type: 'gauge',
      color: '#33b9ce',
      showHistoric: false,
      center: ['50%', '50%'],
      radius: '90%',

      indicators: [
        {
          indicator: 'FALTA',
          grouped: 'status',
          dataType: 'list',
          keyExtract: ['group', 'count'],
          label: 'group',
          value: 'count',
          singleton: true,
          extras: {},
        },
      ],
    },
  },

  multipleGaugeByQuestion: {
    title: 'FALTA',

    position: [0, 0],

    size: [0, 0],

    config: {
      id: 'multiple-gauge-by-question',
      type: 'multipleGauge',
      fillMode: '',
      showValues: true,
      showHistoric: false,

      indicators: [
        {
          indicator: 'FALTA',
          grouped: 'question',
          keyExtract: ['group', 'value', 'groupId'],
          label: 'group',
          value: 'value',
          singleton: true,

          extras: {
            groupNameFormat: 'description',
          },
        },
      ],
    },
  },

  gaugeGenericDataList: {
    title: 'FALTA',

    position: [0, 0],

    size: [0, 0],

    config: {
      id: 'gauge-generic-data-list',
      type: 'gauge',
      fillMode: '',
      color: '#33b9ce',
      showValues: true,
      showHistoric: false,
      maxValue: 100,
      decimals: 1,
      center: ['50%', '50%'],
      radius: '90%',

      indicators: [
        {
          indicator: 'FALTA',
          keyExtract: [
            'group',
            'count',
            'value',
            'groupId',
            'groupName',
          ],

          value: 'value',

          extras: {},

          singleton: true,

          dataType: 'list',
        },
      ],
    },
  },

  gaugeInsightDataList: {
    title: '',

    position: [0, 0],

    size: [1, 2],

    config: {
      id: 'gauge-insight-data-list',

      type: 'gaugeInsight',

      indicators: [
        {
          indicator: 'FALTA',

          keyExtract: [
            'group',
            'count',
            'value',
            'groupId',
            'groupName',
          ],

          value: 'value',

          singleton: true,

          dataType: 'list',

          extras: {
            paletteField: 'group',
            insightEnabled: true,
            palettes: gaugeInsightPalettes,
          },
        },
      ],
    },
  },
}